// extracted by mini-css-extract-plugin
module.exports = {"app_notification":"styles_app_notification__12X51","heading":"styles_heading__2mTjG","controls":"styles_controls__1_o4U"};